'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagAvatarContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useTagAvatarContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useTagAvatarContextValues_unstable(state) {
    const { avatarSize, avatarShape } = state;
    const avatar = _react.useMemo(()=>({
            size: avatarSize,
            shape: avatarShape
        }), [
        avatarShape,
        avatarSize
    ]);
    return {
        avatar
    };
}
